import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { DocumentRequirement } from 'components/Signup/TradingHistory/DocumentRequirement/DocumentRequirement';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};

export const BankStatements = ({ isOptional, isSubmitted, status }: TProps) => {
  const { introducerCompany } = useIntroducerData();
  const isCommerzbank = introducerCompany?.headquarters_name === 'Commerzbank';

  return (
    <DocumentRequirement
      title={t`Business bank statements from the last 3 months`}
      documentType="bank statement"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <>
        <p>
          <Trans>Manually upload account statements as PDF</Trans>
        </p>
        <ul>
          <li>
            <Trans>
              Statements should be provided as a <strong>PDF</strong>,
              preferably as a direct download from your{' '}
              <strong>online banking</strong>
            </Trans>
          </li>
          <li>
            <Trans>
              We need statements from all business accounts that handle{' '}
              <strong>more than 10% of turnover</strong>
            </Trans>
          </li>
          {isCommerzbank ? (
            <>
              <li>
                <Trans>
                  Make sure that the <strong>complete booking text</strong> is
                  shown. To do this, select the{' '}
                  <strong>detailed transaction list</strong>
                </Trans>
              </li>
              <li>
                <Trans>
                  Make sure that the <strong>current account balance</strong> is
                  shown
                </Trans>
              </li>
              <li>
                <Trans>
                  Make sure that the <strong>bank logo</strong> is shown
                </Trans>
              </li>
            </>
          ) : (
            <>
              <li>
                <Trans>
                  Make sure that the <strong>complete booking text</strong> or
                  purpose is shown
                </Trans>
              </li>
              <li>
                <Trans>
                  Make sure that the{' '}
                  <strong>opening and/or closing balance</strong> is shown
                </Trans>
              </li>
              <li>
                <Trans>
                  Make sure the files are not password protected (or share the
                  password with us)
                </Trans>
              </li>
            </>
          )}
          <li>
            <Trans>Maximum file size: 50 MB</Trans>
          </li>
          <li>
            <Trans>
              <strong>Tips</strong> for getting the bank statement upload right
              the first time can be found{' '}
              <a
                href="https://support.iwoca.de/de/articles/12062223-kontoauszuge-tipps-damit-es-auf-anhieb-klappt"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
            </Trans>
          </li>
        </ul>
      </>
    </DocumentRequirement>
  );
};
